import { getHelmetSlug } from '../constants/teamAssets'
import './TeamHelmet.css'

interface TeamHelmetProps {
  abbreviation?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
  title?: string
}

export default function TeamHelmet({
  abbreviation,
  size = 'md',
  className,
  title,
}: TeamHelmetProps) {
  const slug = getHelmetSlug(abbreviation)

  if (!slug) {
    return null
  }

  const classes = [
    'helmet',
    `helmet-${slug}`,
    `helmet-${size}`,
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <span
      className={classes}
      aria-hidden="true"
      title={title ?? abbreviation ?? undefined}
    />
  )
}

